import type { ListImportsParams } from './imports.api';

export const importKeys = {
  all: ['imports'] as const,
  detail: (id: string): readonly unknown[] => [...importKeys.all, 'detail', id] as const,
  list: (params: ListImportsParams): readonly unknown[] => [...importKeys.lists(), params] as const,
  lists: (): readonly unknown[] => [...importKeys.all, 'list'] as const,
};
